module.exports = __webpack_public_path__ + "static/media/postcardRetro1.171602ad.jpg";